import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthProvider, useAuth } from './auth';
import { UnitsProvider } from './units';
import { SiteFooter } from './components/SiteFooter';
import { AcceptInvite } from './pages/AcceptInvite';
import { About } from './pages/About';
import { Announcements } from './pages/Announcements';
import { Attributions } from './pages/Attributions';
import { Calendar } from './pages/Calendar';
import { Catalog } from './pages/Catalog';
import { Dashboard } from './pages/Dashboard';
import { Dens } from './pages/Dens';
import { Family } from './pages/Family';
import { Finance } from './pages/Finance';
import { FinanceReport } from './pages/FinanceReport';
import { Receipt } from './pages/Receipt';
import { Login } from './pages/Login';
import { MeetingDetail } from './pages/MeetingDetail';
import { Meetings } from './pages/Meetings';
import { Members } from './pages/Members';
import { Messaging } from './pages/Messaging';
import { PlatformUnits } from './pages/PlatformUnits';
import { PlatformSettings } from './pages/PlatformSettings';
import { PublicArchive } from './pages/PublicArchive';
import { Roster } from './pages/Roster';
import { RosterImport } from './pages/RosterImport';
import { ScoutDetail } from './pages/ScoutDetail';
import { Website } from './pages/Website';

function Root() {
  const { me, loading } = useAuth();

  if (loading) {
    return (
      <main className="shell">
        <div className="card">Loading…</div>
      </main>
    );
  }

  return (
    <Routes>
      {/* Public — reachable signed-in or not */}
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route
        path="/about"
        element={
          <main className="legal-shell">
            <About />
            <SiteFooter />
          </main>
        }
      />
      <Route
        path="/attributions"
        element={
          <main className="legal-shell">
            <Attributions />
            <SiteFooter />
          </main>
        }
      />
      <Route
        path="/u/:unitId"
        element={
          <main className="legal-shell">
            <PublicArchive />
          </main>
        }
      />

      {me ? (
        <Route
          element={
            <UnitsProvider>
              <AppShell />
            </UnitsProvider>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="units/:unitId/roster" element={<Roster />} />
          <Route path="units/:unitId/roster/import" element={<RosterImport />} />
          <Route path="units/:unitId/scouts/:scoutId" element={<ScoutDetail />} />
          <Route path="units/:unitId/dens" element={<Dens />} />
          <Route path="units/:unitId/family" element={<Family />} />
          <Route path="units/:unitId/catalog" element={<Catalog />} />
          <Route path="units/:unitId/calendar" element={<Calendar />} />
          <Route path="units/:unitId/announcements" element={<Announcements />} />
          <Route path="units/:unitId/messaging" element={<Messaging />} />
          <Route path="units/:unitId/finance" element={<Finance />} />
          <Route path="units/:unitId/finance/report" element={<FinanceReport />} />
          <Route path="units/:unitId/finance/receipt/:paymentId" element={<Receipt />} />
          <Route path="units/:unitId/meetings" element={<Meetings />} />
          <Route path="units/:unitId/meetings/:meetingId" element={<MeetingDetail />} />
          <Route path="units/:unitId/members" element={<Members />} />
          <Route path="units/:unitId/website" element={<Website />} />
          <Route path="admin/units" element={<PlatformUnits />} />
          <Route path="admin/settings" element={<PlatformSettings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      ) : (
        <Route
          path="*"
          element={
            <main className="shell">
              <Login />
              <SiteFooter />
            </main>
          }
        />
      )}
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </AuthProvider>
  );
}
